import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();

  // Show loading while validating (only happens on initial app load)
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading…</div>;
  }

  // No user = token is invalid or expired
  if (!user) {
    localStorage.removeItem("orello_token");
    return <Navigate to="/login" replace />;
  }

  // Check role if specified
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
